// src/api/termsConditionsApi.ts
import api from './api';

export interface TermsConditions {
  id?: number;
  title: string;
  letter_type: string;
  content: string;
}

const termsConditionsApi = {
  // Create Terms & Conditions
  createTermsConditions: async (data: Omit<TermsConditions, 'id'>) => {
    try {
      const response = await api.post('/terms-conditions/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get All Terms & Conditions
  getTermsConditionsList: async () => {
    try {
      const response = await api.get('/terms-conditions/');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get Terms & Conditions By Id
  getTermsConditionsById: async (tcId: number) => {
    try {
      const response = await api.get(`/terms-conditions/${tcId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update Terms & Conditions
  updateTermsConditions: async (tcId: number, data: Partial<TermsConditions>) => {
    try {
      const response = await api.put(`/terms-conditions/${tcId}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete Terms & Conditions
  deleteTermsConditions: async (tcId: number) => {
    try {
      const response = await api.delete(`/terms-conditions/${tcId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default termsConditionsApi;